import React from 'react';
import styled from 'styled-components';
import FeatureComparison from './components/FeatureComparison';
import { Link } from 'react-scroll';
import { Link as DomLink } from 'react-router-dom';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { Col } from 'reactstrap';

// Define styled components for layout and styling
const Container = styled(Col)`
  background: #f6f8fa;
  padding: 40px;
  display: flex;
  justify-content: center;
  flex-direction: column; /* ADD THIS LINE */
`;

const PricingTable = styled.div`
  display: flex;
  max-width: 1200px;
  margin: 0 auto;
  gap: 20px;
  flex-grow: 1;
`;

const Plan = styled.div`
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  flex: 1;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-top: ${props => props.mostPopular ? '5px solid #007bff' : 'none'};
`;

const PlanHeader = styled.h2`
  color: #333;
  margin-bottom: 5px; /* Changed for smaller spacing */
  font-size: 1.25rem; /* Smaller text */
  font-weight: 600; /* Bolder */
`;

const Price = styled.div`
  color: #007bff;
  font-size: 0.79em; /* Smaller text */
  font-weight: bold;
  margin: 10px 0; /* Adjusted margin to handle smaller text changes */
`;

const FeatureList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 10px 0; /* Adjusted margin for a tighter layout */
  flex-grow: 1;
`;

const FeatureTitle = styled.h3`
  font-size: 1em; /* Smaller text */
  font-weight: 600; /* Bolder */
  margin-bottom: 10px;
`;

const Feature = styled.li`
  margin-bottom: 8px; /* Slightly reduced space between features */
  color: #2f2f2f;
  font-size: 0.9em; /* Smaller text */
`;

const Button = styled.button`
  background-color: #22c1c3;
  border: none;
  border-radius: 5px;
  color: white;
  padding: 8px 18px; /* Slightly smaller padding */
  font-size: 0.9em; /* Smaller text */
  cursor: pointer;

  &:hover {
    background-color: #1b9a9a;
  }
`;

const FreePlanButton = styled.button`
  background-color: #0071e1;
  color: white;
  border: 1px solid #0071e1;
  width: 100%;

  &:hover {
    background-color: #005cbf;
    border-color: #005cbf;
  }
`;

const CompareButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 10px 20px;
  margin-bottom: 20px;
  color: #007bff; // Adjust the color as needed
  display: flex; // To align text and icon
  align-items: center; // Center the items vertically
  gap: 8px; // Add some space between text and icon

  &:hover, &:focus {
    background-color: transparent;
    color: #007bff; // Change as per your hover effect need
    text-decoration: none;
  }
`;

const BlueHeadline = styled.div`
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 10px 20px;
  margin-bottom: 20px;
  color: #007bff; // Adjust the color as needed
  font-size: 1.3em;
  text-align: center;

  &:hover, &:focus {
    background-color: transparent;
    color: #007bff; // Change as per your hover effect need
    text-decoration: none;
  }
`;

const CenteredContainer = styled.div`
  display: flex;
  justify-content: center; // Center horizontally
  align-items: center; // Center vertically (optional, if you want vertical centering)
  margin: 20px 0; // Adjust as necessary
`;


const PricingPage = ({ isPublic = true }) => {
  //when Authenticated return different labels and links to buttons:

  return (
    <div>
      <Container>
        {isPublic ? <BlueHeadline>No Credit card required to start 15 days free trial.
        </BlueHeadline> : <BlueHeadline>Choose the plan that's right for your team</BlueHeadline>}
        <PricingTable>

          {/*Basic Plan*/}
          {/*<Plan>*/}
          {/*  <PlanHeader>Basic</PlanHeader>*/}
          {/*  <Price>10$/month per member</Price>*/}
          {/*  {!isPublic ? (*/}
          {/*    <DomLink style={{width:'100%'}} to='/settings/subscribe'><FreePlanButton>Buy Now</FreePlanButton></DomLink> // Replace "/buy-now" with your target page's route*/}
          {/*  ) : (*/}
          {/*    <FreePlanButton>Start 15 days free trial</FreePlanButton>*/}
          {/*  )}*/}
          {/*  <FeatureList>*/}
          {/*    <FeatureTitle>Includes:</FeatureTitle>*/}
          {/*    <Feature>NPS Survey Analysis</Feature>*/}
          {/*    <Feature>Basic Session Recording & Replay (limited)</Feature>*/}
          {/*    <Feature>Public Roadmap</Feature>*/}
          {/*    <Feature>Basic In-App Surveys</Feature>*/}
          {/*    <Feature>Access to Standard Analytics & Insights Dashboard</Feature>*/}
          {/*  </FeatureList>*/}

          {/*</Plan>*/}

          {/*Pro Plan*/}
          <Plan>
            <PlanHeader>Pro</PlanHeader>
            <Price>$12/month per 500 feedback notes a month (unlimited users)</Price>
            {!isPublic ? (
              <DomLink style={{ width: '100%' }} to='/settings/subscribe'><FreePlanButton>Buy
                Now</FreePlanButton></DomLink> // Replace "/buy-now" with your target page's route
            ) : (
              <FreePlanButton>Start 15 days free trial</FreePlanButton>
            )}
            <FeatureList>
              {/*<FeatureTitle>Includes everything in Basic, plus:</FeatureTitle>*/}
                  <Feature>Unlimited users</Feature>
              <Feature>NPS Survey Analysis</Feature>
              <Feature>Feature request & Issues analysis</Feature>
               <Feature>Customer segmentation</Feature>
              <Feature>Custom topics / themes</Feature>
               <Feature>Emerging issues & alerts</Feature>
              <Feature>Editable Roadmap with Feedback Loop</Feature>
              <Feature>Customizable Dashboard</Feature>
              <Feature>Integrations to feedback collection tools and more</Feature>
            </FeatureList>

          </Plan>

          {/* Enterprise Plan */}
          <Plan>
            <PlanHeader>Enterprise custom</PlanHeader>
            <Price>Contact Us</Price>
            <FreePlanButton>Request demo</FreePlanButton>
            <FeatureList>
              <FeatureTitle>Includes everything in Pro, plus:</FeatureTitle>
              {/*<Feature>Unlimited Session Recording & Replay</Feature>*/}
              {/*<Feature>In-App Walkthroughs</Feature>*/}
              {/*<Feature>User Feedback Hub</Feature>*/}
              {/*<Feature>Advanced In-App Surveys</Feature>*/}
              {/*<Feature>Comprehensive Analytics with Predictive Insights</Feature>*/}
              <Feature>Full Customization and Branding Options</Feature>
              {/*<Feature>Advanced Integration and Automation Capabilities</Feature>*/}
              <Feature>Enhanced Access Controls and Permissions</Feature>
              <Feature>Priority Support and Onboarding</Feature>
              <Feature>Compliance and Security Features</Feature>
            </FeatureList>

          </Plan>
        </PricingTable>

      </Container>
      <CenteredContainer>
        <Link to='featureComparison' smooth={true} duration={500} offset={-100}>
          <CompareButton>Compare Plans <ArrowDownwardIcon /></CompareButton>
        </Link>
      </CenteredContainer>
      <div id='featureComparison'>
        <FeatureComparison isPublic={isPublic} />
      </div>
    </div>
  );
};

export default PricingPage;